import { CodebookModel } from 'app/shared/model/shared.model';
import { CROATIA_COUNTRY_ID, CROATIA_COUNTRY_VALUE } from 'app/config/constants';

export interface AddressModel {
  country: CodebookModel[];
  county: CodebookModel[];
  countyString: string;
  cityMunicipality: CodebookModel[];
  cityMunicipalityString: string;
  community: CodebookModel[];
  communityString: string;
  postalCode: string;
  postName: string;
  street: CodebookModel[];
  streetString: string;
  houseNumber: CodebookModel[];
  houseNumberString: string;
}

export const initialAddress = {
  country: [{ id: CROATIA_COUNTRY_ID, value: CROATIA_COUNTRY_VALUE }],
  county: [],
  countyString: '',
  cityMunicipality: [],
  cityMunicipalityString: '',
  community: [],
  communityString: '',
  postalCode: '',
  postName: '',
  street: [],
  streetString: '',
  houseNumber: [],
  houseNumberString: '',
};
